import { AdminPlacesTableRowActionsButtonProps } from './admin-places-table-row-actions-button-props';
import { AdminTableActionButton } from '../admin-table-action-button';
import { AdminTableActionButtonItem } from '../admin-table-action-button-item';
import React from 'react';
import { useAdminPlacesTableController } from './use-admin-places-table-controller';

export const AdminPlacesTableRowActionsButton: React.FunctionComponent<
  AdminPlacesTableRowActionsButtonProps
> = props => {
  const { onDeleteClick, onEditClick } = useAdminPlacesTableController({
    placeName: props.placeName,
    placeId: props.placeId,
  });
  return (
    <AdminTableActionButton>
      <AdminTableActionButtonItem onClick={onEditClick}>
        Edit Place
      </AdminTableActionButtonItem>
      <AdminTableActionButtonItem onClick={onDeleteClick} color="danger">
        Delete Place
      </AdminTableActionButtonItem>
    </AdminTableActionButton>
  );
};
